export default __webpack_public_path__ + "fonts/4ac8fa7322ecd5bec6b7e31af549a07e.svg";